module.exports = __webpack_public_path__ + "img/icon_map_36_off_110.aafa5431.png";